import PropTypes from 'prop-types';
import { useState } from 'react';
import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import {
  StyledGlobalContainer,
  StyledContainer,
  StyledButton,
  StyledContentWrapper,
  StyledInfoContainer,
} from './ExperienceHeader.styles';

function ExperienceHeader({ menuComponent, infoComponent }) {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [isInfoActive, setIsInfoActive] = useState(false);

  const onClick = setter => {
    if (setter === setIsMenuActive) {
      setter(prev => !prev);
      setIsInfoActive(false);
    } else {
      setter(prev => !prev);
      setIsMenuActive(false);
    }
  };

  if (!menuComponent && infoComponent) return null;

  return (
    <StyledGlobalContainer>
      <StyledContainer>
        <Wrapper>
          <StyledContentWrapper>
            <StyledButton
              type="button"
              onClick={() => onClick(setIsMenuActive)}
              isActive={isMenuActive}
            >
              <Icon.HamburgerMenu aria-hidden />
              <span className="sr-only">Related Topics</span>
            </StyledButton>
            <StyledButton
              type="button"
              onClick={() => onClick(setIsInfoActive)}
              isActive={isInfoActive}
            >
              <Icon.Info aria-hidden />
              <span className="sr-only">Info container</span>
            </StyledButton>
          </StyledContentWrapper>
        </Wrapper>
      </StyledContainer>

      <StyledInfoContainer isActive={isMenuActive}>
        {menuComponent && <Wrapper>{menuComponent}</Wrapper>}
      </StyledInfoContainer>

      <StyledInfoContainer isActive={isInfoActive}>
        {infoComponent && <Wrapper>{infoComponent}</Wrapper>}
      </StyledInfoContainer>
    </StyledGlobalContainer>
  );
}
ExperienceHeader.propTypes = {
  menuComponent: PropTypes.element,
  infoComponent: PropTypes.element,
};

ExperienceHeader.defaultProps = {
  menuComponent: null,
  infoComponent: null,
};

export default ExperienceHeader;
